/*eslint-disable*/
import GradeApi from "../api/grade";
import UserApi from "../api/user/user";
import SchoolApi from "../api/school";
import CourseApi from "../api/course";

export default {
    data () {
        return {
            loadingCourses: false,
            loadingSchools: false,
            loadingGrades: false,
            loadingTeachers: false,
            loadingStudents: false
        };
    },
    watch: {
        'form.pointsAccess': {
            handler (val, oldVal) {
                if (oldVal && this.form.school) {
                    this.clearGrades();
                    this.getGrades();
                }
            }
        },
        'form.courses': {
            handler (val, oldVal) {
                if (oldVal) {
                    this.teachers && this.clearTeachers();
                    this.students && this.clearStudents();
                    this.locations && this.clearLocations();
                    this.grades && this.clearGrades();
                    this.clearSchools();
                }
                val && this.schools && this.getSchools();
            },
            deep: true
        },
        'form.school': {
            handler (val, oldVal) {
                if (oldVal) {
                    if (this.teachers) {
                        this.clearTeachers();
                        if (this.isTimetable && this.user.type === 'teacher') {
                            this.form.teacher = this.user;
                        }
                    }
                    this.students && this.clearStudents();
                    this.locations && this.clearLocations();
                    this.clearGrades();
                }
                if (val) {
                    if (this.isTimetable || this.isGradeList || this.isUserList) {
                        this.getTeachers();
                    }
                    if (this.isTimetable) {
                        this.locations = val.locations;
                        this.user.type === 'teacher' && this.getGrades();
                    } else if (!this.isGradeList && this.grades) {
                        this.getGrades();
                    }
                }
            },
            deep: true
        },
        'form.grade': {
            handler (val, oldVal) {
                if (!this.isTimetable) {
                    if (this.teachers) {
                        val && this.getTeachers();
                    }
                    if (this.students) {
                        oldVal && this.clearStudents();
                        val && this.getStudents();
                    }
                }
            }
        },
        'form.teacher': {
            handler (val, oldVal) {
                if (this.isTimetable) {
                    oldVal && this.clearGrades();
                    val && this.getGrades();
                }
            }
        }
    },
    methods: {
        getCourses () {
            if (this.courses.length) {
                return;
            }
            this.loadingCourses = true;
            return CourseApi.list({
                all: true
            }).then((data) => {
                let courses = data.courses;
                this.courses = courses ? courses : [];
                this.loadingCourses = false;
            }).catch(() => {
                this.loadingCourses = false;
                this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
            });
        },
        getSchools () {
            if (this.schools.length) {
                return;
            }
            this.loadingSchools = true;
            let form = {
                all: true
            };
            this.form.courses && (form.coursesIds = this.form.courses.map(value => value.id));
            SchoolApi.list(form).then((data) => {
                let schools = data.schools;
                this.schools = schools ? schools : [];
                this.loadingSchools = false;
            }).catch(() => {
                this.loadingSchools = false;
                this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
            });
        },
        getGrades () {
            if (this.grades.length || !this.form.school) {
                return;
            }
            this.loadingGrades = true;
            let form = {
                schoolId: this.form.school.id,
                access: this.selectedPointsAccess?.mode,
                all: !this.selectedPointsAccess
            };
            this.isTimetable && this.user.type !== 'teacher' && (form.teacherId = this.form.teacher.id);
            GradeApi.list(form)
                .then(response => {
                    let grades = response.grades;
                    this.grades = grades ? grades : [];
                    this.loadingGrades = false;
                }).catch(() => {
                    this.loadingGrades = false;
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
        },
        getTeachers () {
            if (
                this.teachers.length
                || !this.form.school
                || (!this.form.grade && !this.isGradeList && !this.isTimetable && !this.isUserList)
            ) {
                return;
            }
            this.loadingTeachers = true;
            let form = {
                type: 'teacher',
                schoolId: this.form.school.id,
                all: true
            };
            this.form.grade && (form.gradeId = this.form.grade.id);
            UserApi.list(form)
                .then(response => {
                    let teachers = response.users;
                    this.teachers = teachers ? teachers : [];
                    this.loadingTeachers = false;
                }).catch(() => {
                    this.loadingTeachers = false;
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
        },
        getStudents () {
            if (this.students.length || !this.form.grade || !this.form.school) {
                return;
            }
            this.loadingStudents = true;
            UserApi.list({
                type: 'student',
                schoolId: this.form.school.id,
                gradeId: this.form.grade.id,
                status: this.form.status,
                all: true
            }).then(response => {
                let students = response.users;
                this.students = students ? students : [];
                if (this.userId) {
                    this.form.student = this.students.find(student => student.id === this.userId);
                }
                this.loadingStudents = false;
            }).catch(() => {
                this.loadingStudents = false;
                this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
            });
        },
        clearSchools () {
            this.form.school = null;
            this.schools = [];
        },
        clearGrades () {
            this.form.grade = null;
            this.grades = [];
        },
        clearLocations () {
            this.form.location = null;
            this.locations = [];
        },
        clearStudents () {
            this.form.student = null;
            this.students = [];
        },
        clearTeachers () {
            this.form.teacher = null;
            this.teachers = [];
        }
    },
    mounted () {
        if (this.user.type === 'student' || this.user.type === 'olympiads-student') {
            return;
        }
        if (this.schoolId) {
            SchoolApi.show(this.schoolId)
                .then(school => {
                    this.form.school = school;
                    return this.gradeId && GradeApi.show(this.gradeId);
                })
                .then(grade => {
                    grade && (this.form.grade = grade);
                    return this.userId && UserApi.show(this.userId);
                })
                .then(user => {
                    if (user) {
                        if (this.form.student) {
                            this.form.student = user;
                        } else {
                            this.form.teacher = user;
                        }
                    }
                })
                .catch(() => {
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
        }
    },
    computed: {
        isTimetable () {
            return this.$route.name === 'timetable';
        },
        isGradeList () {
            return this.$route.name === 'grade:list';
        },
        isUserList () {
            return this.$route.name === 'user:list';
        },
        teachersPlaceholder () {
            if (this.isTimetable || this.isGradeList) {
                if (this.form.school) {
                    if (!this.teachers.length) {
                        return this.$i18n.t('fields.fields_schoolHasNoTeachers');
                    }
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('fields.fields_selectSchoolFirst');
            }
            if (this.form.grade || this.form.school) {
                if (!this.teachers.length) {
                    return this.$i18n.t('fields.fields_schoolHasNoTeachers');
                }
                return this.$i18n.t('common.common_placeholder_enterToSearch');
            }
            return this.$i18n.t('fields.fields_selectSchoolFirst');
        },
        studentsPlaceholder () {
            if (this.form.grade) {
                if (!this.students.length) {
                    return this.$i18n.t('fields.fields_gradeHasNoStudents');
                }
                return this.$i18n.t('common.common_placeholder_enterToSearch');
            }
            return this.$i18n.t('fields.fields_selectGradeFirst');
        },
        gradesPlaceholder () {
            if (this.isTimetable) {
                if (this.form.teacher) {
                    if (!this.grades.length) {
                        return this.$i18n.t('fields.fields_teacherHasNoGrades');
                    }
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                if (this.user.type === 'teacher') {
                    if (!this.form.school) {
                        return this.$i18n.t('fields.fields_selectSchoolFirst');
                    }
                    if (!this.grades.length) {
                        return this.$i18n.t('fields.fields_schoolHasNoGrades');
                    }
                    return this.$i18n.t('common.common_placeholder_enterToSearch');
                }
                return this.$i18n.t('fields.fields_selectTeacherFirst');
            }
            if (this.form.school) {
                if (!this.grades.length) {
                    return this.$i18n.t('fields.fields_schoolHasNoGrades');
                }
                return this.$i18n.t('common.common_placeholder_enterToSearch');
            }
            return this.$i18n.t('fields.fields_selectSchoolFirst');
        },
        isTeacherDisabled () {
            return !this.teachers.length;
        },
        isStudentDisabled () {
            return !this.students.length;
        },
        isGradeDisabled () {
            return !this.grades.length;
        }
    }
}
